<template>
    <k-panel class="border">
        <k-panel-row v-if="tranche.details.summary.shortDescription">
            <div slot="left" class="border-b pb-4">{{ tranche.details.summary.shortDescription }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Industry
            </div>
            <div slot="right">
              {{ tranche.trancheType | enumValue }}
            </div>
        </k-panel-row>

        <k-panel-row v-if="tranche.productTypes">
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Product type
            </div>
            <div slot="right">
              <div v-for="productType in tranche.productTypes" :key="productType" class="text-right">
                {{ productType }}&nbsp;
              </div>
            </div>
        </k-panel-row>
        <k-panel-row v-if="tranche.details.investmentStructure">
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Investment structure
            </div>
            <div slot="right">
                {{ tranche.details.investmentStructure }}
            </div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Interest rate
            </div>
            <div slot="right">{{ tranche.interestRate | numeralFormat('0.00') }}%</div>
        </k-panel-row>
        <k-panel-row v-if="tranche.term">
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Term
            </div>
            <div slot="right">
                {{ tranche.term }}
            </div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Tranche amount
            </div>
            <div slot="right">{{tranche.currencySymbol}}{{ tranche.principalIssued | numeralFormat('0,0.') }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Available to invest
            </div>
            <div slot="right">{{tranche.currencySymbol}}{{ tranche.principalAvailable | numeralFormat('0,0.') }}</div>
        </k-panel-row>
        <k-panel-row v-if="tranche.collateral">
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Collateral
            </div>
            <div slot="right">
                <div v-for="collateral in tranche.collateral" :key="collateral" class="text-right">
                    {{ collateral }}&nbsp;
                </div>

            </div>
        </k-panel-row>
        <k-panel-row v-if="tranche.details.ltv">
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                LTV
            </div>
            <div slot="right">
                {{ tranche.details.ltv  | numeralFormat('0.00') }}%
            </div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Nominal value
            </div>
            <div slot="right">{{ tranche.nominalValue | currencyFormat(tranche.currencySymbol) }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Issue date
            </div>
            <div slot="right">{{ tranche.issueDate | dateFormat }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Interest commencement date
            </div>
            <div slot="right">{{ tranche.interestCommencementDate | dateFormat }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Maturity date
            </div>
            <div slot="right">{{ tranche.maturityDate | dateFormat }}</div>
        </k-panel-row>
        <k-panel-row>
            <div slot="left">
                <img src="/img/icon/dot_03_m.svg" class="inline-block mr-2 icon">
                Tranche number
            </div>
            <div slot="right" class="text-right">{{ tranche.trancheNumber }}</div>
        </k-panel-row>
    </k-panel>
</template>

<script>
export default {
    props: {
        tranche: {
            type: Object,
            required: true
        }
    }
};
</script>


<style scoped>
.icon {
    height: 12px;
    width: 12px;
}
</style>
